import { ApihttpMethods, ApiTypes, EAuthorizationType, EApiReponseType, EStatus, ETokenSource } from "./general-enums";

export interface ModuleData {
  path?: string;
  location?: string;
  moduleName?: string;
  rootComponent?: string;
  description?: string;
  registered?: boolean;
  componentName?:string
}

export class DatasourceModel {
  apiMapperViewModel: ApiMapperViewModel;
  inputs: ApiMapperParamsViewModel[];
  outputs: string[];
  paths: string[];
  tokenSource: ETokenSource;
  arrayBody:boolean;
  BodyType:string;
  /**
   * The per-parameter links saved with the data source. The server replaces the
   * whole set: leaving this out keeps what is stored, an empty array clears it.
   */
  children?: any[];
  constructor() {
    this.apiMapperViewModel = new ApiMapperViewModel();
    this.inputs = [];
    this.outputs = [];
    this.paths = [];
  }
}

export class ApiMapperViewModel {
  Id: number |any;
  Name: string |any;
  Description: string |any;
  URL: string |any;
  HttpMethod: ApihttpMethods |any;
  MediaTypes: string |any;
  Type: ApiTypes |any;
  Status: EStatus |any;
  ApiMapperParams: any[] |any;
  IsSecured: boolean;
  ApiReponseType: EApiReponseType |any;
  SiteId: number |any;
  ContractName: string |any;
  ContentType: string |any;
  Accept: string |any;
  WebMethodName: string |any;
  AuthorizationKeys: AuthorizationKeyVM[] |any;
  AuthorizationType: EAuthorizationType |any;
  ParentId?: number;
  EnableLog?: boolean;

  constructor() {
    this.Id = 0;
    this.Name = "";
    this.Description = "";
    this.URL = "";
    this.HttpMethod = 0;
    this.MediaTypes = "0";
    this.Type = 0;
    this.Status = 0;
    this.ApiMapperParams = [];
    this.IsSecured = true;
    this.ApiReponseType = 0;
    this.SiteId = 0;
    this.ContractName = "";
    this.ContentType = "";
    this.Accept = "";
    this.WebMethodName = "";
    this.AuthorizationKeys = [];
    this.ParentId = 0;
  }
}

export class AuthorizationKeyVM {
  Key: string;
  Value: string;
  TokenSource: ETokenSource
}

export class AuthorizationKeyResVM {
  key: string;
  value: string;
  tokenSource: ETokenSource
}

export class ApiMapperDetailsViewModel {

  id: number;
  name: string;
  description: string;
  url: string;
  httpMethod: ApihttpMethods;
  mediaTypes: string;
  type: ApiTypes;
  status: EStatus;
  apiMapperParams: any[];
  isSecured: boolean;
  apiReponseType: EApiReponseType;
  siteId: number;
  contractName: string;
  contentType: string;
  accept: string;
  webMethodName: string;
  authorizationKeys: AuthorizationKeyResVM[];
  authorizationType: EAuthorizationType;
  inputs: ApiMapperParamsResViewModel[];
  outputs: string;
  path: string;
  /** Dead since the parent moved to apiMapperParamChild; never populated. */
  parentId?: number;
  /** The stored per-parameter links of this data source. */
  apiMapperParamChild?: ApiMapperParamChildLink[];
}

/** A row of the data sources list, as returned by GetApiMapperBySiteId. */
export class ApiMapperListItem {
  id: number;
  name: string;
  description: string;
  url: string;
  httpMethod: ApihttpMethods;
  type: ApiTypes;
  status: EStatus;
  authorizationType: EAuthorizationType;
  siteId: number;
  enableLog: boolean;
  /** The data source this one runs after. Returned by the endpoint already. */
  parentId?: number;
}

/** Identity of the copy created by DuplicateDataSource. */
export class DuplicatedDataSource {
  id: number;
  name: string;
  sourceId: number;
}

export class TestApiMapperDetailsViewModel {

  Id: number;
  Name: string;
  Description: string;
  URL: string;
  HttpMethod: ApihttpMethods;
  MediaTypes: string;
  Type: ApiTypes;
  Status: EStatus;
  ApiMapperParams: any[];
  IsSecured: boolean;
  ApiReponseType: EApiReponseType;
  Inputs?: ApiMapperParamsResViewModel[];
  Outputs?: string;
  Path?: string;
  ParentId?: number;
  AuthorizationKeys: AuthorizationKeyVM[];
  AuthorizationType: EAuthorizationType;
  Obj?:{}
}

export class ApiMapperParamsViewModel {
  Id: number;
  ApiMapperId: number;
  ParamName: string;
  ParamOrder: number;
  Direction: number;
  ParamType: number;
  CreatedById: number;
  constructor(
    Id,
    ApiMapperId,
    ParamNamem,
    ParamOrder,
    Direction,
    ParamType,
    CreatedById
  ) {
    (this.Id = 0),
      (this.ApiMapperId = 0),
      (this.ParamName = ""),
      (this.ParamOrder = 0),
      (this.Direction = 0),
      (this.ParamType = 0),
      (this.CreatedById = 0);
  }
}

export class ApiMapperParamsResViewModel {
  id: number;
  apiMapperId: number;
  paramName: string;
  paramOrder: number;
  direction: number;
  paramType: number;
  createdById: number;
  constructor(
    id,
    apiMapperId,
    paramNamem,
    paramOrder,
    direction,
    paramType,
    createdById
  ) {
    (this.id = 0),
      (this.apiMapperId = 0),
      (this.paramName = ""),
      (this.paramOrder = 0),
      (this.direction = 0),
      (this.paramType = 0),
      (this.createdById = 0);
  }
}

export class DataSourceListDDL {
  id: number;
  name: string;
  /** The data source this one runs after, when it is part of a chain. */
  parentId?: number;

  constructor(_id: number, _name: string, _parentId?: number) {
    this.id = _id;
    this.name = _name;
    this.parentId = _parentId;
  }
}

/**
 * An output field of a data source, with the param id a link points at. The id
 * is what goes into the children list sent with the save.
 */
export class ApiMapperOutputParam {
  id: number;
  paramName: string;
  alias?: string;
}

/**
 * One stored "this parameter reads a field of another data source" row.
 * The server keys it by (apiMapperId, paramName) and resolves the value from
 * parentId (the data source to run first) and apiMapperParamChildId (its
 * output parameter).
 */
export class ApiMapperParamChildLink {
  id: number;
  apiMapperId: number;
  paramName: string;
  /** Id of the output parameter of the data source that runs first. */
  apiMapperParamChildId: number;
  /** Id of the data source that runs first. */
  parentId: number;
  executionOrder: number;
}

/** One "field feeds this parameter" row, as the chain map shows it. */
export class ParentFieldMapping {
  /** Parameter of this data source that receives the value. */
  paramName: string;
  /** Field that the value is read from. */
  parentField: string;
  /** Data source that runs first for this one parameter. */
  parentApiId: number;
  parentApiName: string;
  /** Id of that data source's output parameter, which is what gets saved. */
  parentOutputParamId: number;
  /** Where the parameter is sent: Header, Body, Query string or Path. */
  area: string;
  /** False when the field or the data source can no longer be resolved. */
  resolved: boolean;
}

export class TestDataSourceVM {
  id: number;
  bodyParams: ApiMapperParamsViewModel[];
  headerParams: ApiMapperParamsViewModel[];
  queryParams: ApiMapperParamsViewModel[];
  path?: any[];
  firstStepData: TestApiMapperDetailsViewModel;
  unAssigendOutParams?: any[];
  assigendOutParams?: any[];
  dataSourceHeader?:string;
  bodyType?:string;
  arrayBodyParams?:any[];
}


export class BasicAuthentication {
  Username : string;
  Password : string;
}


